import { Component, DestroyRef, Input, Output, EventEmitter, effect, inject, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppSettings } from '@services/settings/app-settings.service';
import { MicrosoftAuthService } from '@services/core/authentication.service';
import { UserService } from '@services/core/user.service';
declare var slideToggle: any;

@Component({
	selector: 'header',
	templateUrl: './header.component.html',
	styleUrls: ["./header.component.css"],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit{
	@Input() appSidebarTwo: any;
	@Output() appSidebarEndToggled = new EventEmitter<boolean>();
	@Output() appSidebarMobileToggled = new EventEmitter<boolean>();
	@Output() appSidebarEndMobileToggled = new EventEmitter<boolean>();

	protected logo = document.location.origin + "/assets/img/logo.png";
	protected profilePhotoURL: any
	protected userData: any
	public entities: any[] = []
	public entitiesTemp: any[] = []
	public appSettings = inject(AppSettings)
	private userService = inject(UserService)
	private cdr = inject(ChangeDetectorRef)
	private authMicrosoft = inject(MicrosoftAuthService)

	toggleAppSidebarMobile() {
		this.appSidebarMobileToggled.emit(true);
	}

	toggleAppSidebarEnd() {
		this.appSidebarEndToggled.emit(true);
	}

	toggleAppSidebarEndMobile() {
		this.appSidebarEndMobileToggled.emit(true);
	}

	toggleAppTopMenuMobile() {
		var target = document.querySelector('.app-top-menu');
		if (target) {
			slideToggle(target);
		}
	}

	toggleAppHeaderMegaMenuMobile() {
		this.appSettings.appHeaderMegaMenuMobileToggled = !this.appSettings.appHeaderMegaMenuMobileToggled;
	}



	constructor(){
		effect(()=> {
			this.userData = this.userService.userData()
			this.profilePhotoURL = this.userService.userPhoto()
			this.cdr.markForCheck()
		})
		effect(() => {
			this.entities = this.userService.sharingEntities()
			this.entitiesTemp = this.entities
			this.cdr.markForCheck()
		})
  }

  private destroyRef = inject(DestroyRef)

  ngOnInit(): void {
		
	}
	
	logout() {
		this.authMicrosoft.clearSesion()
		this.authMicrosoft.logout().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
			next: (res) => {
				const url = res?.url || (typeof res === 'string' ? res : null)
				window.location.href = url || '/'
			},
			error: () => { window.location.href = '/' }
		})
	}

	changeEntity(entity: any){
		this.userService.sharingEntity.set(entity)
		this.userService.changeEntitySelected(entity).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(()=>{})
	}

	filtrarEntidades(event: any){
		const find = event.toLowerCase()
		this.entities = this.entitiesTemp.filter(entity => {
			const rut = entity.rut.toString() + "-" + entity.dv.toLowerCase()
			return entity.name.toLowerCase().includes(find)	|| 
			rut.toString().includes(find)
		})
	}
}
